import { render, staticRenderFns } from "./OrderToStockout.vue?vue&type=template&id=56aafb71&scoped=true"
import script from "./OrderToStockout.vue?vue&type=script&lang=js"
export * from "./OrderToStockout.vue?vue&type=script&lang=js"
import style0 from "./OrderToStockout.vue?vue&type=style&index=0&id=56aafb71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aafb71",
  null
  
)

export default component.exports